import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { Marker, type Map, type LngLatLike } from 'mapbox-gl'
import _isNil from 'lodash/isNil'
import _isUndefined from 'lodash/isUndefined'

import MapPolygonMarker from 'components/MapPolygonMarker/MapPolygonMarker'
import { type Emissions } from 'types/data'

export default function useSelectedEmissionsMarkers(
  map: Map | undefined,
  selectedEmissions: Emissions[],
  filteredEmissions: Emissions[],
  handleMarkerClick: (emission: Emissions) => void
) {
  useEffect(() => {
    if (
      _isNil(map) ||
      _isUndefined(map) ||
      _isUndefined((map as any).style) ||
      filteredEmissions.length === 0
    ) {
      return
    }

    const mapMarkers = selectedEmissions.map(
      (emission: Emissions, index: number) => {
        const markerContainer = document.createElement('div')
        const root = ReactDOM.createRoot(markerContainer)

        root.render(
          React.createElement(MapPolygonMarker, {
            selectionIndex: index + 1,
            onClick: handleMarkerClick.bind(null, emission)
          })
        )

        const marker = new Marker({
          element: markerContainer
        })

        const coordinates = emission.feature.geometry.coordinates
        marker.setLngLat(coordinates as unknown as LngLatLike)
        marker.addTo(map)

        return marker
      }
    )

    return () => {
      mapMarkers.forEach((marker: Marker) => marker.remove())
    }
  }, [map, selectedEmissions, filteredEmissions, handleMarkerClick])
}
